import React, { useState } from 'react';

const ImageSlider = () => {
    const image1 = "https://ostbookstorage.blob.core.windows.net/ostblobstorage/book_cover/1-zoo-cover.jpg";
    const image2 = "https://ostbookstorage.blob.core.windows.net/ostblobstorage/app/app/book_combo_deal.png";
    const image3 = "https://ostbookstorage.blob.core.windows.net/ostblobstorage/app/app/my_story_pass.png";

    const images = [
        image1,
        image2,
        image3
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((currentIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentIndex((currentIndex - 1 + images.length) % images.length);
    };

    return (
        <div className="slider-container">
            <div className="slider" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                {images.map((image, index) => (
                    <img key={index} src={image} width="1 0%"alt={`Image ${index + 1}`} alt={"book"}/>
                ))}
            </div>

            <button onClick={prevSlide}>Previous</button>
            <button onClick={nextSlide}>Next</button>
        </div>
    );
};

export default ImageSlider;
